import React from "react";
import { Box, Heading, Text, VStack, Container } from "@chakra-ui/react";

const utilitiesBlock = [
  "Access to the first series of tournaments with $300,000 in prizes.",
  "Monthly freeroll tournaments funded by the project’s revenue stream.",
  "Eligibility for future governance tokens and other project airdrops.",
  "Discounts of up to 30% for regular tournaments linked to NFT rarity. ",
  "Exclusive rights to create your own custom tournaments and earn rewards.",
];

function index() {
  return (
    <Container maxW="container.xl" mb={32} w="100%" id="utility">
      <Box>
        <VStack w="100%" spacing={16}>
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            NFT UTILITIES
          </Heading>
          <VStack w="100%">
            {utilitiesBlock.map((text) => (
              <Blocks key={text} text={text} />
            ))}
          </VStack>
        </VStack>
      </Box>
    </Container>
  );
}

function Blocks({ text }) {
  return (
    <Box
      bg="rgba(255, 255, 255, .15)"
      borderRadius="15px"
      w="100%"
      textAlign="center"
      py="5"
      px={3}
      backdropFilter="blur(5px) brightness(100%) "
    >
      <Text>{text}</Text>
    </Box>
  );
}

export default index;
